import { render, staticRenderFns } from "./PointName.vue?vue&type=template&id=49086a34&scoped=true&"
import script from "./PointName.vue?vue&type=script&lang=js&"
export * from "./PointName.vue?vue&type=script&lang=js&"
import style0 from "./PointName.vue?vue&type=style&index=0&id=49086a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49086a34",
  null
  
)

export default component.exports